import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, CheckCircle, TrendingUp, Euro } from 'lucide-react';

/**
 * QuoteStats — top stats strip for the Quotes admin page.
 * Receives the pre-computed `stats` object from the parent (fetched via quotesAPI.getStats()).
 *
 * Props:
 *   stats — { total, accepted, conversionRate, acceptedValue, ... }
 */
const QuoteStats = ({ stats }) => {
  const { t } = useTranslation();

  if (!stats) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#3b82f620', color: '#3b82f6' }}>
          <FileText size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.dashboard.stats.totalLeads')}</p>
          <p className="stat-value">{stats.total}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#10b98120', color: '#10b981' }}>
          <CheckCircle size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.dashboard.stats.converted')}</p>
          <p className="stat-value">{stats.accepted}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#f59e0b20', color: '#f59e0b' }}>
          <TrendingUp size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.dashboard.stats.conversionRate')}</p>
          <p className="stat-value">{stats.conversionRate}%</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#10b98120', color: '#10b981' }}>
          <Euro size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.quotes.stats.acceptedValue')}</p>
          <p className="stat-value">€{stats.acceptedValue.toFixed(0)}</p>
        </div>
      </div>
    </div>
  );
};

export default QuoteStats;
